<mat-chip-list>
  <mat-chip class="mat-basic-chip chip-new"
            customToolTip [contentTemplate]="tooltipT" [delay]="0"
            contentType="template"
            tooltipClass="mat-tooltip"
            selected>{{ 'real_conversions.correction_status' | translate }} {{'real_conversions.disabled' | translate}}
  </mat-chip>

  <ng-template #tooltipT>
    <div class="widget-tooltip" [innerHTML]="'real_conversions.text_report_not_corrected' | translate"></div>
  </ng-template>
</mat-chip-list>
